module.exports = __webpack_public_path__ + "2d0c8f786f51dfee2fb550733ff65db0.svg";